
export const checkStockMap = [
  {
    name: '发行价',
    field: 'issue_price',
    unit: 'issue',
    value: '',
  },
  {
    name: '中签率',
    field: 'success_rate',
    unit: 'winning',
    value: '',
  },
]

export const checkBondMap = [
  {
    name: '溢价率',
    field: 'premium_rate',
    unit: 'premium',
    value: '',
  },
  {
    name: '中签率',
    field: 'success_rate',
    unit: 'winning',
    value: '',
  },
]